<template>
	<v-container>
		<v-overlay :value="spinning"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
		<v-row align="center" justify="center">
			<v-col cols="12" xs="12" sm="7" md="7" lg="7">
				<v-card class="card-rounded elevation-1 mt-3" style="width: 100%; height: auto">
					<div>
						<v-container align="center" justify="center" class="pa-5 pb-0">
							<v-list-item three-line>
								<v-list-item-content>
									<v-list-item-title class="mb-1 text-center"><h1>Verification</h1></v-list-item-title>
									<v-list-item-subtitle class="text-center">We need to verify your details</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-container>

						<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
							<v-form ref="locumVerificationForm" :value="valid">
								<v-row
									><v-col>
										<v-select v-model="selectedIndustry" :items="listOfIndustries" label="Select your industry" outlined :rules="industryRules">
										</v-select> </v-col
								></v-row>

								<v-row
									><v-col>
										<v-select v-model="industryProfessionPair" :items="relevantProfessions" label="Select your profession" outlined :rules="professionRules">
										</v-select> </v-col
								></v-row>

								<v-row
									><v-col>
										<v-select v-model="regbody" :items="regBodyOptions" label="Select your professional registration body" outlined :rules="regbodyRules">
										</v-select> </v-col
								></v-row>

								<v-row
									><v-col>
										<v-text-field
											v-model="regnumber"
											:placeholder="computedRegNumberPlaceholder"
											:readonly="!this.regbody"
											label="Enter your registration number"
											outlined
											:append-outer-icon="computedRegNumberAssertation"
											:loading="this.regnumberState == 'busy'"
											:error-messages="computedRegNumberErrMessage"
											:success-messages="computedRegNumberSucMessage"
											:rules="regnumberRules"
											@input="onInputRegistrationNumber"
										></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col> <v-text-field v-model="idpassport" label="Enter your ID/Passport number" outlined :rules="idpassportRules"></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col> <v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field> </v-col
								></v-row>

								<v-row>
									<v-col>
										<v-select
											v-model="provinceSelected"
											outlined
											:items="province_computed"
											persistent-hint
											label="Select your province"
											:rules="provinceRules"
										></v-select>
									</v-col>
								</v-row>

								<v-row>
									<v-col>
										<v-select
											v-model="province_region"
											outlined
											:items="region_computed"
											:disabled="!provinceSelected"
											:label="provinceSelected ? 'Enter your City/District/Region' : 'Please select province above'"
											:rules="regionRules"
										></v-select>
									</v-col>
								</v-row>

								<v-row
									><v-col> <v-text-field v-model="suburb" label="Enter suburb" outlined :rules="suburbRules"></v-text-field> </v-col
								></v-row>
							</v-form>
						</v-card-text>
					</div>
					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container>
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										large
										class="text-none button-rounded continue-signup-button"
										style="text-transform: none !important"
										color="primary"
										@click="SubmitForm()"
										>{{ impersonationMode ? 'Update' : 'Complete sign up' }}<v-icon>arrow_forward</v-icon></v-btn
									>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { bus } from '@/main';
import router from '@/router';

import store from '@/store';
import { provinceRegionPairs, getImpersonationCache, apiPost, apiPut } from '@utils';

import { Tracking } from '@/utils';

export default {
	props: {
		solo: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		name: 'LocumVerificationForm',
		impersonationMode: getImpersonationCache().impersonationMode,

		valid: false,

		spinning: false,
		provinceSelected: null,

		regbody: null,
		regbodyRules: [v => !!v || 'Required'],
		regnumber: null,
		regnumberRules: [v => !!v || 'Required'],
		idpassport: null,
		idpassportRules: [v => !!v || 'Required'],
		streetAddress: null,
		streetAddressRules: [v => !!v || 'Required'],
		province_region: null,
		provinceRules: [v => !!v || 'Required'],
		regionRules: [v => !!v.province || 'Required'],
		industryProfessionPair: null,
		professionRules: [v => !!v || 'Required'],
		selectedIndustry: null,
		industryRules: [v => !!v || 'Required'],

		suburb: null,
		suburbRules: [v => !!v || 'Required'],

		form: false,

		registerBodies: ['HPCSA', 'SAPC', 'SANC', 'Other', 'SAVC'],

		province_regions: provinceRegionPairs,

		regnumberState: 'no-input',

		rules: {
			// email: v => (v || "").match(/@/) || "Please enter a valid email",
			length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
			password: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
			required: v => !!v || 'This field is required',
		},
	}),
	computed: {
		...mapGetters('tenant', ['tenant']),

		industriesConfigsObj() {
			return store.getters.configs.industriesV2;
		},
		listOfIndustries() {
			return Object.keys(this.industriesConfigsObj);
		},
		user() {
			return store.getters.user;
		},
		industryIsNoneOrPresent() {
			let industry = this.user.industry;
			return industry == 'Other';
		},
		regBodyOptions() {
			//"HPCSA", "SAPC", "SANC", "OTHER", "SAVC"
			let result = ['Please select a profession'];
			if (this.industryProfessionPair) {
				switch (this.industryProfessionPair.industry) {
					case 'Other':
						result = ['HPCSA', 'SAPC', 'SANC', 'OTHER'];
						break;
					case 'Optometry':
						result = ['HPCSA'];
						break;
					case 'Pharmacy':
						result = ['SAPC'];
						break;
					case 'Nursing':
						result = ['SANC'];
						break;
					case 'Dental':
						result = ['HPCSA'];
						break;
					case 'General Medical':
						result = ['HPCSA'];
						break;
					case 'Radiology':
						result = ['HPCSA'];
						break;
					case 'Veterinary':
						result = ['SAVC'];
						break;
					default:
						result = ['HPCSA', 'SAPC', 'SANC', 'OTHER'];
						break;
				}
			}
			return result;
		},

		relevantProfessions() {
			let listOfProfessions = [];
			let result = [];
			if (!this.user.profile) {
				console.error('industry or profile not present for user', this.user);
			} else {
				const industry = this.industriesConfigsObj[this.selectedIndustry];
				if (industry) {
					listOfProfessions = industry.professions.map(x => x.name);
				}
			}

			for (const profession of listOfProfessions) {
				result.push({ text: profession, value: { industry: this.selectedIndustry, profession } });
			}
			return result;
		},

		province_regions_computed() {
			let getpr = store.getters.getProvinceRegions;
			let result = [];
			if (getpr && 'Items' in getpr) {
				getpr.Items.forEach(item => {
					item.subs.forEach(region => {
						result.push({ province: item.name, region: region });
					});
				});
			}
			return result;
		},
		province_computed() {
			let result = [];
			this.province_regions.forEach(set => {
				if (!(set.province in result)) {
					result.push(set.province);
				}
			});
			return result;
		},
		region_computed() {
			let result = [];
			if (this.provinceSelected) {
				this.province_regions.forEach(set => {
					if (this.provinceSelected == set.province) {
						result.push({ text: set.region, value: set, province: set.province, region: set.region });
					}
				});
			}
			return result;
		},
		computedRegNumberPlaceholder() {
			let def = 'Select your registration body above';
			let NA = '**Registration number not required for OTHER';
			let block = 'your {0} registration number';
			if (!this.regbody) {
				return def;
			}

			if (this.regbody == 'OTHER') {
				return NA;
			} else {
				return block.replace('{0}', this.regbody);
			}
		},
		computedRegNumberAssertation() {
			if (this.regnumberState == 'idle') {
				return '';
			} //nothing
			if (this.regnumberState == 'busy') {
				return 'hourglass_full';
			} //busy
			if (this.regnumberState == 'positive') {
				return 'done';
			} //all good
			if (this.regnumberState == 'negative') {
				return 'priority_high';
			} //did not check out
			return '';
		},
		computedRegNumberErrMessage() {
			if (this.regnumberState == 'negative') {
				return 'Your registration number is not valid';
			}
			return '';
		},
		computedRegNumberSucMessage() {
			if (this.regnumberState == 'positive') {
				return 'Your registration number is valid';
			}
			return '';
		},
	},
	mounted() {
		Tracking.track('Locum_Verification_Step', {});
		if (this.solo) {
			bus.$on('intent:submit-forms:' + this.name, data => {
				bus.$emit('update:spinning', true);
				this.postToBackend(data);
			});
		} else {
			bus.$on('intent:submit-forms', data => {
				bus.$emit('update:spinning', true);
				this.postToBackend(data);
			});
		}

		const { profile, profession, professional_body, professional_number, idpassport, address: { province, region, suburb, street } = {} } = this.user;

		this.selectedIndustry = profile;
		this.industryProfessionPair = { profession, industry: profile };
		this.regbody = professional_body;
		this.regnumber = professional_number;
		this.idpassport = idpassport;
		this.streetAddress = street;
		this.provinceSelected = province;
		this.province_region = { province, region };
		this.suburb = suburb;
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
		bus.$off('intent:submit-forms:' + this.name);
	},
	methods: {
		zendeskAssistance() {
			window.zE('webWidget', 'chat:addTags', ['locum', 'verification-step']);
			window.zE('webWidget', 'chat:send', 'Hi, I would like assistance with the verification step.');
			window.zE('webWidget', 'open');
		},
		validate() {
			return this.$refs.locumVerificationForm.validate();
		},
		reset() {
			this.$refs.locumVerificationForm.reset();
		},
		resetValidation() {
			this.$refs.locumVerificationForm.resetValidation();
		},
		async postToBackend() {
			this.spinning = true;

			const body = {
				industry: this.selectedIndustry,
				profession: this.industryProfessionPair.profession,
				address: {
					province: this.provinceSelected,
					region: this.province_region.region,
					suburb: this.suburb,
					street: this.streetAddress,
				},
				professional_body: this.regbody,
				professional_number: this.regnumber,
				idpassport: this.idpassport,
				email: store.getters.user.email,
			};

			console.log('tenant', this.tenant);

			//TODO: Move checks to tenant model
			if (this.tenant && this.tenant.settings && this.tenant.settings.workflow && this.tenant.settings.workflow.professionalProfile) {
				if (this.tenant.settings.workflow.professionalProfile.autoApprove) {
					body.approved = this.tenant.settings.workflow.professionalProfile.autoApprove;
				}
			}

			const postData = isCreate => {
				const apiPromise = isCreate ? apiPost('professionals', body) : apiPut(`professionals/profile`, body);
				apiPromise
					.then(response => {
						bus.$emit('form-submitted', { form: this.name, status: response.status });
						if (response.status == 200) {
							store.commit('SET_USER', response.data.data); //refresh the users state.
							bus.$emit('navToDashboard');
							router.push('/').catch(() => {}); //goto dashboard, dashboard will take over from here.
						}
					})
					.finally(() => {
						bus.$emit('update:spinning', false);
						this.spinning = false;
					});
			};

			if (this.impersonationMode) {
				return postData(false);
			}

			Object.assign(body, {
				first_name: 'name' in store.getters.user ? store.getters.user.name : store.getters.user.first_name,
				last_name: 'family_name' in store.getters.user ? store.getters.user.family_name : store.getters.user.last_name,
				contact: 'phone_number' in store.getters.user ? store.getters.user.phone_number : store.getters.user.contact,
			});

			postData(true);
		},
		SubmitForm() {
			let valid = this.validate();
			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			}
		},
		onInputRegistrationNumber() {
			if (!this.regbody) {
				return null;
			}
			this.regnumberState = 'busy';
			if (this.regnumber.slice(0, 2) == 'no') {
				setTimeout(() => (this.regnumberState = 'negative'), 2500);
			} else {
				setTimeout(() => (this.regnumberState = 'positive'), 2500);
			}
		},
	},
};
</script>
